import React, { useEffect, useRef } from 'react';
import { useTranslation } from '../contexts/LanguageContext';
import { useSettingsSheet } from '../context/SettingsSheetContext';
import ThemeToggle from './ThemeToggle';
import LanguageSelector from './LanguageSelector';
import OfflineSettingsSection from './OfflineSettingsSection';
import '../styles/components/SettingsSheet.css';

// Consolidated settings panel: theme, language, and offline-downloads
// management behind a single Header gear (and, from Task 6, other entry
// points that jump straight to a section, e.g. open('downloads')). Reads
// its open/section/close state from SettingsSheetContext instead of props
// so any component can drive it.
export default function SettingsSheet() {
  const { t } = useTranslation();
  const { isOpen, section, close } = useSettingsSheet();
  const downloadsRef = useRef(null);

  // Scroll the requested section into view whenever the sheet opens with one
  // set. Guarded for jsdom, which does not implement scrollIntoView.
  useEffect(() => {
    if (!isOpen || section !== 'downloads') return;
    downloadsRef.current?.scrollIntoView?.();
  }, [isOpen, section]);

  if (!isOpen) return null;

  return (
    <div
      className="settings-overlay"
      onClick={close}
      role="dialog"
      aria-modal="true"
      aria-label={t('settings')}
    >
      <div className="settings-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="settings-head">
          <h2>{t('settings')}</h2>
          <button
            type="button"
            className="settings-close"
            onClick={close}
            aria-label={t('install.dismiss')}
          >
            &times;
          </button>
        </div>

        <div className="settings-controls">
          <ThemeToggle />
          <LanguageSelector />
        </div>

        <div className="settings-section" ref={downloadsRef}>
          <h3 className="settings-section-title">{t('offline.downloads')}</h3>
          <OfflineSettingsSection />
        </div>
      </div>
    </div>
  );
}
